import { createContext } from 'react';

const StepperApiContext = createContext({});
const StepperStateContext = createContext({});

const StepApiContext = createContext({});

export { StepperApiContext, StepperStateContext, StepApiContext };
